exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!../../node_modules/ng-admin/build/ng-admin.min.css"), "");

// module
exports.push([module.id, ".app{height:100%;background-color:$lightBgColor}.subscription-logo-url{max-height:50px;max-width:50px}.copyToClipboard{margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/app.styl
// module id = 742
// module chunks = 0